export const homePath = '/email';
